import * as types from "./mutation-types";

export default {
  [types.SET_CONCEDENTES_CONTATOS](state, payload) {
    state.concedentes_contatos = payload;
  },
  [types.SET_CONCEDENTE_CONTATO](state, payload) {
    state.concedente_contato = payload;
  },
  [types.SET_PAGINATION](state, payload) {
    state.pagination = payload;
  },
  [types.SET_ISLOADING](state, payload) {
    state.is_loading = payload;
  },
};
